module.exports = __webpack_public_path__ + "static/media/inactiveempty.2f993e01.png";